import Swal from "sweetalert2";

/**
 * @param message Mensagem a ser exibida
 * @param type Tipo de popup: 'error', 'question', 'success', 'info', 'warning'
 */
export function Alerta(
  message: string = 'Algo deu errado!',
  type: 'error' | 'question' | 'success' | 'info' | 'warning' = 'error'
) {
  const config = {
    error: { title: 'Atenção!', class: 'swal2-error' },
    success: { title: 'Sucesso!', class: 'swal2-success' },
    info: { title: 'Atenção!', class: 'swal2-info' },
    warning: { title: 'Atenção!',  class: 'swal2-warning' },
    question: { title: 'Confirmação', class: 'swal2-question' },
  };

  const { title, class: cssClass } = config[type];

  Swal.fire({
    title: title,
    text: message,
    timer: message.trim().split(/\s+/).length * 750,
    timerProgressBar: true,
    position: 'top',
    padding: '2.5rem',
    showConfirmButton: false,
    customClass: {
      popup: 'swal2-compact-popup',
      title: `${cssClass}-title`,
      timerProgressBar: `${cssClass}-timer`,
    },
    buttonsStyling: true,
  });
}
